import React, { cloneElement } from 'react';

import { Flex, Paper, PaperProps, Title } from '@mantine/core';

interface OverviewCardProps extends PaperProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

export function OverviewCard({ title, icon, children, ...paperProps }: OverviewCardProps) {
  return (
    <Paper
      p="md"
      withBorder
      h="100%"
      {...paperProps}
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        position: 'relative',
        ...paperProps.style
      }}>
      <Flex direction="row" align="center" gap={10} mb={10}>
        {cloneElement(icon as React.ReactElement, {
          style: { width: 20, height: 20, size: 20 },
          w: 20,
          h: 20
        })}
        <Title order={4}>{title}</Title>
      </Flex>
      <Flex direction="column" style={{ flex: 1, minHeight: 0 }}>
        {children}
      </Flex>
    </Paper>
  );
}
